import { reactive } from 'vue'
import type { MockupType } from '../../types'
import type { RoomType } from '/@/common/rooms/types'
import type { Project, Section } from '/@/common/projects/types'
import { createModal } from '/@/core/elements/modal'
import type { MockupTemplateType } from '/@/common/templates/types'
import type { TabType } from './utils'

export interface ViziInfo {
  name: string
  dataUrl?: string
  project: Pick<Project, 'id' | 'name'> | null
  section: Pick<Section, 'id' | 'name'> | null
  templateId: string | null
  templateType?: MockupTemplateType | null
  templateName?: string | null
  wantsCustomBg: boolean
  customBg: string | null
  mockupType: MockupType
  isTraining: boolean
  roomType?: RoomType
  roomTypeExtra?: string
}

export const viziInfo = reactive<ViziInfo>({
  name: 'Untitled',
  project: null,
  section: null,
  templateId: null,
  templateType: null,
  wantsCustomBg: false,
  customBg: null,
  mockupType: 'MOCKUP',
  isTraining: false,
  roomType: 'BEDROOM',
})

export interface NewViziModalData {
  mode: 'default' | 'strict'
  viziTypes: MockupType[]
  type?: MockupType
  dailyPlayId?: string | undefined
  taskId?: string | undefined
  designChallengeId?: string | undefined
  project?: Pick<Project, 'id' | 'name'> | undefined
  section?: Pick<Section, 'id' | 'name'> | undefined
  tabType?: TabType
  demoDisabled?: boolean
  offscreen?: boolean
  onSubmit?: () => void
}

const { api, component } = createModal<NewViziModalData>(
  'NewViziModal',
  () => import('./viz3/NewViziModal.vue'),
  {
    mode: 'default',
    type: undefined,
    viziTypes: ['MOCKUP', 'EDITORIAL'],
    dailyPlayId: undefined,
    taskId: undefined,
    designChallengeId: undefined,
    project: undefined,
    section: undefined,
    tabType: undefined,
    demoDisabled: false,
    offscreen: false,
  },
)

export const useNewViziModal = api
export const NewViziModal = component
